import React from "react";
import { Box } from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";

const ThemeToggle = ({ darkMode, setDarkMode }) => {
  return (
    <Box
      onClick={() => setDarkMode(!darkMode)}
      sx={{
        width: 44,
        height: 22,
        borderRadius: "50px",
        position: "relative",
        cursor: "pointer",
        background: darkMode
          ? "linear-gradient(90deg,#1e3a8a,#4338ca)"
          : "linear-gradient(90deg,#93c5fd,#c7d2fe)",
        display: "flex",
        alignItems: "center",
        px: 0.5,
        transition: "all 0.3s ease-in-out",
        boxShadow: darkMode
          ? "inset 0 1px 4px rgba(0,0,0,0.5)"
          : "inset 0 1px 4px rgba(0,0,0,0.15)",
        "&:hover": {
          transform: "scale(1.05)",
        },
      }}
    >
      {/* Knob */}
      <Box
        sx={{
          position: "absolute",
          top: 2,
          left: darkMode ? 22 : 2,
          width: 18,
          height: 18,
          borderRadius: "50%",
          background: darkMode ? "#0f172a" : "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.3s ease-in-out",
          boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        }}
      >
        {darkMode ? (
          <DarkModeIcon sx={{ fontSize: 12, color: "#818cf8" }} />
        ) : (
          <LightModeIcon sx={{ fontSize: 12, color: "#3b82f6" }} />
        )}
      </Box>
    </Box>
  );
};

export default ThemeToggle;
